// extracted by mini-css-extract-plugin
module.exports = {"colorDot":"ReportByEmployeesTable_colorDot__2CMZ8"};